// @flow
import React from 'react'
import Link from 'gatsby-link'
import styled, { css } from 'styled-components'

import { lighten, darken } from 'polished'
import hello from 'hello-color'

import colors from '../theme/colors'
import * as _colors from '../theme/_colors'
import mapProps from '../theme/mapProps'
import {
  Headline,
  ContentRow,
  ViewportRow,
  ViewportContainer,
  ViewportContent,
  PageContainer,
  Container,
  Block,
  Fill,
  Flex,
  Title,
  Text,
  Paragraph,
} from '../styleguide'

export default (props: any) => (
  <ContentRow>
    <Flex align="center" justify="center">
      <Form>
        <FormContainer>
          <Paragraph weight="black" scale="1" mt="0" color={colors.gray[5]}>
            Sign in
          </Paragraph>
          <Input type="text" placeholder="email" />
          <Fill flex="fourth" scale="1" />
          <Input type="secure" placeholder="password" />
          <Fill flex="fourth" scale="1" />

          <Button
          // color={colors.red[6]}
          >
            Sign in
          </Button>
        </FormContainer>
      </Form>
    </Flex>
  </ContentRow>
)

const FormContainer = styled(Fill).attrs({ column: true, flex: 'half', p: 3, px: 'viewport' })`
  min-height: 20rem;
  min-width: 18rem;
  border-radius: 0.5rem;
  background-color: ${colors.gray[1]};
`
const Form = styled.div`
  display: flex;
  align-items: center;
  padding-bottom: 1.5rem;
  margin-bottom: 1.5rem;
  box-shadow: 0 .1875rem 0 #e6ebf1;
`
const Label = styled.label`
  color: #6b7c93;
  font-weight: 300;
  letter-spacing: 0.025em;
`
const Input = styled.input`
  color: '#424770';
  font-size: 1rem;
  line-height: 2rem;
  letter-spacing: '0.025em';
  ::placeholder {
    color: #aab7c4;
  }

  display: block;
  min-width: 16rem;
  max-width: 30rem;
  padding: 0.5rem 1rem;
  box-shadow: rgba(50, 50, 93, 0.14902) 0 .0625rem .1875rem, rgba(0, 0, 0, 0.0196078) 0 .0625rem 0;
  border-radius: 0.25rem;
  background: ${colors.white};
  transition: all 150ms ease;
  &:hover {
    box-shadow: rgba(50, 50, 93, 0.109804) 0 .125rem .0625rem, rgba(0, 0, 0, 0.0784314) 0 0 .0625rem;
  }
  &:focus {
    box-shadow: rgba(50, 50, 93, 0.109804) 0 .25rem .375rem, rgba(0, 0, 0, 0.0784314) 0 .0625rem .1875rem;
  }
`

const Button = styled.button`
  white-space: nowrap;
  border: 0;
  outline: 0;
  display: inline-block;
  font-size: 1.5rem;
  line-height: 2rem;
  min-width: 10rem;
  max-width: 30rem;
  padding: 0.5rem 1rem;

  color: #fff;
  border-radius: .25rem;
  font-size: .9375rem;
  font-weight: 600;
  letter-spacing: 0.025em;
  text-decoration: none;
  transition: all 150ms ease;
  background-color: ${colors.indigo[6]};

  box-shadow: 0 .25rem .375rem rgba(50, 50, 93, 0.11), 0 .0625rem .1875rem rgba(0, 0, 0, 0.08);
  &:hover {
    color: #fff;
    cursor: pointer;
    background-color: ${colors.indigo[5]};
    transform: translateY(-.0625rem);
    box-shadow: 0 .4375rem .875rem rgba(50, 50, 93, 0.1), 0 .1875rem .375rem rgba(0, 0, 0, 0.08);
  }
  &:active {
    color: #fff;
    cursor: pointer;
    background-color: ${colors.indigo[8]};
    transform: translateY(.0625rem);
    box-shadow: 0 .1875rem .3125rem rgba(50, 50, 93, 0.1), 0 0 .0625rem rgba(0, 0, 0, 0.08);
  }

  ${mapProps({
    color: color => {
      const lighter = lighten(0.05, color)
      const darker = darken(0, color)
      return css`
        color: ${color};
        background-color: ${colors.white};
        &:hover {
          background-color: ${lighter};
        }
        &:active {
          background-color: ${darker};
        }`
    },
  })};
`



// WEBPACK FOOTER //
// ./src/pages/signin.js